import { z } from "zod";
/**
 * Body of step 1 of the crediting flow (`POST /api/crediting/:invoiceId`).
 * The reason is required at saisie even though the DB column is nullable
 * (nullable = backward-compat for historical avoirs). See issue #416.
 */
export const CreditInvoicePayloadSchema = z.object({
    // trim() before min(1): a whitespace-only reason must be rejected at the API
    // boundary (the front already trims, but the schema is the server guarantee).
    // max(500): the column is unbounded TEXT — bound the free-text input.
    creditReason: z.string().trim().min(1).max(500),
});
/**
 * Corps de `PUT /api/invoices/update-payment/:invoiceId`. `checkNumber` est
 * accepté quel que soit le `payment` — le service applique la garde #815 :
 * persisté seulement si `payment === "chèque"`, `null` sinon.
 */
export const UpdateInvoicePaymentPayloadSchema = z.discriminatedUnion("paid", [
    z.object({ paid: z.literal(false) }),
    z.object({
        paid: z.literal(true),
        // min(1) : "" est réservé à l'état « non payée » (#984) — une déclaration
        // de paiement sans mode produirait « Payée par  » et des exports vides.
        payment: z.string().min(1),
        checkNumber: z.string().trim().max(50).optional(),
    }),
]);
//# sourceMappingURL=invoice.model.js.map